import axios from "axios";

const api = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
    withCredentials: true, // <- send the httpOnly cookie
    headers: {
        "Content-Type": "application/json",
    }
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401) {
      try {
        await api.post("/api/logout");
      } catch {}
      // redirect to login page
    //   router.push("/");
      window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

// ✅ Intercept Unauthorized API Responses (401)
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response?.status === 401) {
//       console.log("User is unauthorized, logging out...");

//       // ✅ Dynamically import the store and logout action
//       const { store } = await import("./redux/store");
//       const { logoutUser } = await import("./redux/features/auth-slice");

//       store.dispatch(logoutUser());
//       window.location.href = "/";
//     }
//     return Promise.reject(error);
//   }
// );

//COOKIE WAY (Optional)
// Optional: centralize 401 handling
// api.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     if (err?.response?.status === 401) {
//       // not authenticated or cookie expired
//       Router.push("/");
//     }
//     return Promise.reject(err);
//   }
// );

export default api;
